import { Box, withStyles } from '@material-ui/core';
import { centerBoxProps } from 'globals/utils';
import InviteCustomerSrc from 'assets/images/dashboard/invite-customer.svg';
import FsHeaderLarge from 'ui-elements/typography/FsHeaderLarge';
import FsCaption from 'ui-elements/typography/FsCaption';

export const WrapperBox = withStyles(() => ({
  root: {
    width: '100%',
  },
}))(Box);

export const ImageContainer = withStyles(
  ({ spacing, breakpoints, transitions }) => ({
    root: {
      ...centerBoxProps,
      width: `calc(100% + ${spacing(6)})`,
      minHeight: 200,
      marginBottom: spacing(2),
      backgroundColor: '#CFD6F5',
      borderRadius: spacing(1),
      margin: spacing(0, -3),
      '& svg': {
        height: '100%',
        width: 'auto',
      },
      backgroundImage: `url(${InviteCustomerSrc})`,
      backgroundSize: `auto 90%`,
      backgroundPosition: `50% 100%`,
      backgroundRepeat: `no-repeat`,
      transition: transitions.create(['min-height']),
      [breakpoints.up('sm')]: {
        minHeight: 350,
        marginBottom: spacing(3),
      },
    },
  })
)(Box);

export const Title = withStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(1),
  },
}))(FsHeaderLarge);

export const Caption = withStyles(({ palette }) => ({
  root: {
    color: palette.grey[300],
  },
}))(FsCaption);
